import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Box status list',
  description: 'Displays box statuses'
};



// WEBPACK FOOTER //
// ./app/widgets.new/BoxStatusList/index.js